import JobApplication from ".";

export const jobsApplicationRoutes = () => [
  {
    path: "/admin/job-applications",
    component: JobApplication,
    layout: "admin",
    routeType: "admin",
    title: "Jobs Management",
  },
];